/**
 * 쿠키 최대 만료 시간(참고 : https://stackoverflow.com/questions/3290424/set-a-cookie-to-never-expire)
 * 2038년 그대로 사용하면 여차할 때 overflow 할 수 있을 것 같아 안전하게 2037 년으로 변경함
 */
export const COOKIE_MAX_EXPIRES_DATE = new Date('2037-01-19 04:14:07');
export const APP_DOWNLOAD_PAGE_TRY_URL_PARAM_KEY = 'try_url';
export const APP_DONWLOAD_PAGE_TRY_SCHEME_PARAM_KEY = 'try_scheme';
export const TRIGGER_COMMAND_KEY = 'trigger_command';

// 한국어 숫자 포맷팅 상수
export const KOREAN_FORMAT = {
  HUNDRED_MILLION_THRESHOLD: 100000000, // 1억
  HUNDRED_MILLION_DIVISOR: 10000000, // 1천만 (억 단위 나누기용)
  TEN_THOUSAND_THRESHOLD: 10000, // 1만
  TEN_THOUSAND_DIVISOR: 1000, // 1천 (만 단위 나누기용)
} as const;

// 영어 숫자 포맷팅 상수
export const GLOBAL_FORMAT = {
  MILLION_THRESHOLD: 999950, // M 단위 경계값
  MILLION_DIVISOR: 100000, // 10만 (M 단위 나누기용)
  THOUSAND_THRESHOLD: 1000, // 1천 (K 단위 경계값)
  THOUSAND_DIVISOR: 100, // 100 (K 단위 나누기용)
} as const;

export const COOKIE_KEY_DEVICE_ID = '_kpdid';
export const COOKIE_KEY_IDENTIFIER_ID = '_kpiid';
